// extracted by mini-css-extract-plugin
module.exports = {"dateInput":"IDad5","label":"IDt7","inputWrapper":"IDad7","calendarIcon":"IDad9","input":"IDmp","error":"IDxt","errorMsg":"IDacf"};